//LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";

//HOOK
import { useGetProperties } from "../../hooks/useGetProperties";

//CONFIG
import appConfig from "../../config/appConfig";

//COMPONENTI
import LoadingIndicator from "../Loaders/LoadingIndicator";
import ImmobiliGrid from "../Properties/ImmobiliGrid";
import ImmobiliList from "../Properties/ImmobiliList";


const LastProperties: React.FC = () => {

    const { t } = useTranslation();
    const currentView = appConfig.ui.immobiliPage.defaultView;
    const ViewComponent = (currentView === 'list') ? ImmobiliList : ImmobiliGrid;

    // Ittieni utlimi ommobili inseriti
    const { properties, loading, error } = useGetProperties( appConfig.agency.id , { 
        limit: 3,
        offset: 0,
        withCount: false,
        filters: {
            
        },
            orderBy: {
            field: 'insertionDate',
            direction: 'desc',
        },
        status:[],
        portal: 56
    })

    // ---- Gestione Stati Iniziali ----
    if (loading) return <LoadingIndicator />;

    if (error) {
        console.error("Errore caricamento Immobili:", error);
        return <div className="alert alert-warning">{t('common.loadingError', 'Errore caricamento dati.')}</div>;
    }

    if (!properties || properties.length === 0) {
        <div className="text-center p-5">{t('propertyList.notFound.title')}</div>;
    }

    return(
        <section className="space-ptb">
            <div className="container-fluid">
                <p className="mb-2 sub-title">{t('homePage.lastPropertiesAdd.subTitle')}</p>
                <h2 className="mb-3">{t('homePage.lastPropertiesAdd.title')}</h2>
                <div className="row">
                    <div className="col-12">
                        <div className="row justify-content-center">
                            <ViewComponent
                                properties={properties}
                                loading={loading}
                                error={null}
                                basePath="immobile"
                                labelSold={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default LastProperties;